/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WhitepaperLookupsDto } from '../../models/whitepaper-lookups-dto';

export interface GetWhitepaperLookups$Params {
}

export function getWhitepaperLookups(http: HttpClient, rootUrl: string, params?: GetWhitepaperLookups$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WhitepaperLookupsDto>>> {
  const rb = new RequestBuilder(rootUrl, getWhitepaperLookups.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WhitepaperLookupsDto>>;
    })
  );
}

getWhitepaperLookups.PATH = '/api/whitepaper/lookups';
